import { useEffect, useMemo, useState } from "react";
import Marquee from "react-fast-marquee";
import {
  getAllDashboardTransaction,
  getDashboardGeneralSettings,
  getTickerCoins,
} from "../../../api/coin";
import loadable from "@loadable/component";
import pMinDelay from "p-min-delay";
import ExchangeLineChart from "../Crypto/Exchange/ExchangeLineChart";
import LitecoinBarChart from "../Crypto/Exchange/LitecoinBarChart";
import BtcDigitalChartIndex4 from "./Index4/BtcDigitalChartIndex4";
import DigitalChartIndex4 from "./Index4/DigitalChartIndex4";
import { usePrices } from "../../../context/SocketContext";
import { useAuth } from "../../../context/AuthContext";
import logo from "../../../assets/images/logo/logo.png";
import { Link } from "react-router-dom";
import { Sparklines, SparklinesLine } from "react-sparklines";

const WidgetChartIndex3 = loadable(() =>
  pMinDelay(import("./Index3/WidgetChartIndex3"), 1000)
);

const sampleData = [8, 3, 8, 6, 5, 3, 5, 7, 5];
const overviewData = [
  { id: 1, title: "ETH/USD", stroke: "#FD5353" },
  { id: 2, title: "BTC/USD", stroke: "#3AB67A" },
  { id: 3, title: "LTC/USD", stroke: "#FD5353" },
  { id: 4, title: "XRP/USD", stroke: "#FD5353" },
  { id: 5, title: "LTC/USD", stroke: "#3AB67A" },
  { id: 6, title: "XRP/USD", stroke: "#FD5353" },
];

const statusColor = {
  pending: "label-warning",
  confirmed: "label-success",
  unconfirmed: "label-danger",
};

const Home = () => {
  const { user } = useAuth();

  const [coin, setCoin] = useState([]);
  const [row_one, setRowOne] = useState([]);
  const [row_two, setRowTwo] = useState([]);
  const [row_three, setRowThree] = useState([]);
  const [tableData, setTableData] = useState([]);
  // const { coinPrices, coin24HPer, coinColors } = usePrices();
  // console.log("SOCKET PRICE", coinPrices);

  // useEffect(() => {
  //   getAllCoins(1, 1000).then(({ data }) => {
  //     console.log("DATA in Home", data)
  //     if (data) {
  //       setCoin(data);
  //     }
  //   });
  //   getDashboardGeneralSettings().then((data) => {
  //     if (data) {
  //       setRowOne(data.row_one);
  //       setRowTwo(data.row_two);
  //       setRowThree(data.row_three);
  //     }
  //   });
  //   getAllDashboardTransaction().then((result) => setTableData(result?.data));
  // }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fire all 3 requests in parallel instead of sequentially
        const [tickerData, generalSettings, transactionResult] =
          await Promise.all([
            getTickerCoins(),
            getDashboardGeneralSettings(),
            getAllDashboardTransaction(),
          ]);

        if (tickerData) setCoin(tickerData);

        if (generalSettings) {
          setRowOne(generalSettings.row_one);
          setRowTwo(generalSettings.row_two);
          setRowThree(generalSettings.row_three);
        }

        setTableData(transactionResult?.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  // const prices = usePrices();
  // console.log("PRICE")

  // const coinPrices = {};
  // const coin24HPer = {};
  // const coinColors = {};

  // prices.forEach(({ coinId, price, percentChange, color }) => {
  //   coinPrices[coinId] = price;
  //   coin24HPer[coinId] = percentChange;
  //   coinColors[coinId] = color;
  // });

  const prices = usePrices();

  const { coinPrices, coin24HPer, coinColors } = useMemo(() => {
    const priceMap = {};
    const percentMap = {};
    const colorMap = {};

    prices.forEach(({ coinId, price, percentChange, color }) => {
      priceMap[coinId] = price;
      percentMap[coinId] = percentChange;
      colorMap[coinId] = color;
    });

    return {
      coinPrices: priceMap,
      coin24HPer: percentMap,
      coinColors: colorMap,
    };
  }, [prices]);
  const [code, setCode] = useState("");

  async function uuidToFormatted16DigitCode(uuid) {
    // Remove hyphens
    const hex = uuid.replace(/-/g, "");

    // Convert hex string to Uint8Array
    const bytes = new Uint8Array(hex.length / 2);
    for (let i = 0; i < hex.length; i += 2) {
      bytes[i / 2] = parseInt(hex.substr(i, 2), 16);
    }

    // Hash the UUID bytes with SHA-256
    const hashBuffer = await crypto.subtle.digest("SHA-256", bytes);
    const hashArray = Array.from(new Uint8Array(hashBuffer));

    // Convert hash bytes to numeric string
    const hashHex = hashArray
      .map((b) => b.toString(16).padStart(2, "0"))
      .join("");
    // eslint-disable-next-line no-undef
    const numericString = BigInt("0x" + hashHex)
      .toString()
      .slice(0, 16);

    // Format: space every 4 digits
    return numericString.replace(/(.{4})/g, "$1 ").trim();
  }
  const handleConvert = async (uuid) => {
    const result = await uuidToFormatted16DigitCode(uuid); // ✅ Wait for Promise
    setCode(result); // ✅ Set the resolved string
  };
  useEffect(() => {
    if (user?.id) {
      handleConvert(user?.id);
    }
  }, [user?.id]);
  const colors = ["bg-warning", "bg-secondary", "bg-pink"];
  return (
    <>
      <div className="row">
        <div className="col-xxl-12">
          <div className="overflow-hidden bg-transparent dz-crypto-scroll shadow-none">
            <div className="js-conveyor-example">
              <ul className="crypto-list" id="crypto-webticker">
                <Marquee speed={80} loop={0} pauseOnHover={false}>
                  {coin?.map((item, index) => {
                    const coinPrice = prices.find(
                      (item) => item.coinId === coin.id
                    );
                    return (
                      <>
                        <Link
                          to={`/coin-details/${item.id}`}
                          className="text-decoration-none"
                          key={index}
                        >
                          <div
                            className="card overflow-hidden"
                            style={{ marginLeft: "0.5rem" }}
                            key={index}
                          >
                            <div className="card-body d-flex align-items-center ">
                              <div className="me-4">
                                <p className="mb-2 fs-13">
                                  {item.name} ({item.symbol})
                                </p>
                                <h4
                                  className="heading mb-0"
                                  style={{ color: coinPrice?.color }}
                                >
                                  {coinPrice?.percentChange || "0.00%"}
                                </h4>
                              </div>
                              <img
                                src={`${process.env.REACT_APP_API_BASE_URL}/uploads/${item.logo}`}
                                className="rounded-circle"
                                style={{ height: "50px", width: "50px" }}
                                alt={item.symbol}
                              />
                            </div>
                          </div>
                        </Link>
                      </>
                    );
                  })}
                </Marquee>
              </ul>
            </div>
          </div>
        </div>
        {/* from dashboard 4 index-3 coin card ==> */}
        <div className="col-xl-12">
          <div className="row">
            <div className="col-xl-3 col-lg-6 col-sm-6">
              <div className="card prim-card">
                <div className="card-body py-3">
                  <svg
                    width="64"
                    height="64"
                    viewBox="0 0 64 64"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M45.333 9.3335H18.6663C16.191 9.3335 13.817 10.3168 12.0667 12.0672C10.3163 13.8175 9.33301 16.1915 9.33301 18.6668V45.3335C9.33301 47.8088 10.3163 50.1828 12.0667 51.9332C13.817 53.6835 16.191 54.6668 18.6663 54.6668H45.333C47.8084 54.6668 50.1823 53.6835 51.9327 51.9332C53.683 50.1828 54.6663 47.8088 54.6663 45.3335V18.6668C54.6663 16.1915 53.683 13.8175 51.9327 12.0672C50.1823 10.3168 47.8084 9.3335 45.333 9.3335ZM27.9997 14.6668H35.9997V22.6668H27.9997V14.6668ZM22.6663 49.3335H18.6663C17.6055 49.3335 16.5881 48.9121 15.8379 48.1619C15.0878 47.4118 14.6663 46.3944 14.6663 45.3335V41.3335H22.6663V49.3335ZM35.9997 49.3335H27.9997V41.3335H35.9997V49.3335ZM49.333 45.3335C49.333 46.3944 48.9116 47.4118 48.1614 48.1619C47.4113 48.9121 46.3939 49.3335 45.333 49.3335H41.333V41.3335H49.333V45.3335ZM49.333 36.0002H14.6663V18.6668C14.6663 17.606 15.0878 16.5885 15.8379 15.8384C16.5881 15.0883 17.6055 14.6668 18.6663 14.6668H22.6663V25.3335C22.6663 26.0407 22.9473 26.719 23.4474 27.2191C23.9475 27.7192 24.6258 28.0002 25.333 28.0002H49.333V36.0002ZM49.333 22.6668H41.333V14.6668H45.333C46.3939 14.6668 47.4113 15.0883 48.1614 15.8384C48.9116 16.5885 49.333 17.606 49.333 18.6668V22.6668Z"
                      fill="white"
                    />
                  </svg>
                  <div className="d-flex">
                    <h4 className="number mt-2">{code}</h4>
                    <div className="rec-design">
                      <div className="rec-design1"></div>
                      <div className="rec-design2"></div>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="prim-info">
                      <span>Account Holder</span>
                      <h4>
                        {user?.firstName} {user?.lastName}
                      </h4>
                    </div>
                    <div
                      className="master-card position-relative "
                      style={{ top: "-9px" }}
                    >
                      {/* <svg
                        width="88"
                        height="56"
                        viewBox="0 0 88 56"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <circle cx="28" cy="28" r="28" fill="#FF5B5B" />
                        <circle cx="60" cy="28" r="28" fill="#F79F19" />
                      </svg> */}
                      <img
                        src={logo}
                        className="img-fluid"
                        alt="logo"
                        style={{ maxWidth: "88px", maxHeight: "56px" }}
                      />
                      <span className="text-white d-block mt-1">Pinance</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {row_one.slice(0, 3).map((item, ind) => (
              <div className="col-xl-3 col-lg-6 col-sm-6" key={ind}>
                <Link
                  to={`/coin-details/${item.id}`}
                  className="text-decoration-none"
                >
                  <div className={`card card-box ${colors[ind]}`}>
                    <div className="card-header border-0 pb-0">
                      <div className="chart-num-days">
                        {/* <p>
                        <i className="fa-solid fa-sort-down me-2"></i>
                        4%(30 days)
                      </p> */}
                        <h2 className="count-num text-white">
                          {item.maxSupply}
                        </h2>
                      </div>
                      <img
                        src={`${process.env.REACT_APP_API_BASE_URL}/uploads/${item.logo}`}
                        className="rounded-circle"
                        style={{ height: "50px", width: "50px" }}
                        alt={item.symbol}
                      />
                    </div>
                    <div className="card-body p-0 custome-tooltip">
                      <div className="mt-xl-4">
                        <WidgetChartIndex3 />
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>

        {/* from exvhange page */}
        <div className="col-xl-12">
          <div className="row">
            {row_two.slice(0).map((item, i) => (
              <div className="col-lg-6 col-xl-3 col-md-6" key={i}>
                <Link
                  to={`/coin-details/${item.id}`}
                  className="text-decoration-none"
                >
                  <div className="card overflow-hidden">
                    <div className="card-body py-0 pt-4">
                      <div className="d-flex align-items-center justify-content-between">
                        <h4 className="fs-14 font-w400 mb-0">{item.name}</h4>
                        <div className="d-flex align-items-center">
                          <h2 className="count-num">{item.totalSupply}</h2>
                          {/* <span
                          className={`fs-16 font-w500  ps-2 ${
                            i === 1 ? "text-danger" : "text-success"
                          }`}
                        >
                          <i className={`bi pe-2 bi-caret-green-fill`}></i>
                        </span> */}
                        </div>
                      </div>
                      {i % 2 == 0 ? (
                        <ExchangeLineChart />
                      ) : (
                        <LitecoinBarChart />
                      )}
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>

        {/* from crypto page added in both portfolio and dashboard/ market watch card slider ==> */}
        {/* <div className="col-xl-12">
          <MarketCardSlider />
        </div> */}

        {/* 2 chart from index/ dashboard 4  */}
        <div className="col-xl-6 col-xxl-6">
          <Link
            to={`/coin-details/${row_three[0]?.id}`}
            className="text-decoration-none"
          >
            <div className="card">
              <div className="card-body d-flex align-items-center">
                {/* <svg
                  width="42"
                  height="42"
                  viewBox="0 0 42 42"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M21.5566 23.893C21.1991 24.0359 20.8009 24.0359 20.4434 23.893L16.6064 22.3582L21 31.1454L25.3936 22.3582L21.5566 23.893Z"
                    fill="#AC4CBC"></path>
                  <path
                    d="M21 20.8846L26.2771 18.7739L21 10.3304L15.7229 18.7739L21 20.8846Z"
                    fill="#AC4CBC"></path>
                  <path
                    d="M21 0.00012207C9.40213 0.00012207 0.00012207 9.40213 0.00012207 21C0.00012207 32.5979 9.40213 41.9999 21 41.9999C32.5979 41.9999 41.9999 32.5979 41.9999 21C41.9871 9.40762 32.5924 0.0129395 21 0.00012207ZM29.8417 20.171L22.3417 35.171C21.9714 35.9121 21.0701 36.2124 20.3294 35.8421C20.0387 35.697 19.8034 35.4617 19.6583 35.171L12.1583 20.171C11.9253 19.7032 11.9519 19.1479 12.2284 18.7043L19.7284 6.70453C20.2269 6.00232 21.1996 5.83661 21.9018 6.33511C22.0451 6.43674 22.1701 6.56125 22.2717 6.70453L29.7712 18.7043C30.0482 19.1479 30.0747 19.7032 29.8417 20.171Z"
                    fill="#AC4CBC"></path>
                </svg> */}
                <img
                  src={`${process.env.REACT_APP_API_BASE_URL}/uploads/${row_three[0]?.logo}`}
                  alt="symbol"
                  className="rounded-circle"
                  style={{
                    width: "42px",
                    height: "42px",
                    objectFit: "cover",
                  }}
                />

                <div className="ms-3">
                  <h2 className="text-black fs-20 mb-0 font-w600">
                    {row_three[0]?.name}
                  </h2>
                  <span>
                    {(() => {
                      const coinPrice = prices.find(
                        (item) => item.id === coin.id
                      );
                      if (!coinPrice) return null;

                      return (
                        <>
                          {coinPrice.price} (
                          <span style={{ color: coinPrice.color }}>
                            {coinPrice.percentChange}
                          </span>
                          )
                        </>
                      );
                    })()}
                  </span>
                </div>
              </div>
              <DigitalChartIndex4 />
              <div className="card-footer">
                {/* <div className="row">
                <div className="col text-center">
                  <h5 className="font-weight-normal">1230</h5>
                  <span>Type A</span>
                </div>
                <div className="col text-center">
                  <h5 className="font-weight-normal">1230</h5>
                  <span>Type A</span>
                </div>
                <div className="col text-center">
                  <h5 className="font-weight-normal">1230</h5>
                  <span>Type A</span>
                </div>
              </div> */}
              </div>
            </div>
          </Link>
        </div>
        <div className="col-xl-6 col-xxl-6">
          <Link
            to={`/coin-details/${row_three[1]?.id}`}
            className="text-decoration-none"
          >
            <div className="card">
              <div className="card-body d-flex align-items-center">
                {/* <svg
                  width="42"
                  height="42"
                  viewBox="0 0 42 42"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M28.5 16.5002C28.4986 14.844 27.156 13.5018 25.5003 13.5H16.5002V19.4999H25.5003C27.156 19.4985 28.4986 18.1559 28.5 16.5002Z"
                    fill="#FFAB2D"></path>
                  <path
                    d="M16.5002 28.5H25.5003C27.1569 28.5 28.5 27.157 28.5 25.5003C28.5 23.8432 27.1569 22.5001 25.5003 22.5001H16.5002V28.5Z"
                    fill="#FFAB2D"></path>
                  <path
                    d="M21 0.00012207C9.4021 0.00012207 9.15527e-05 9.40213 9.15527e-05 21C9.15527e-05 32.5979 9.4021 41.9999 21 41.9999C32.5979 41.9999 41.9999 32.5979 41.9999 21C41.9866 9.40762 32.5924 0.0133972 21 0.00012207ZM31.5002 25.4998C31.4961 28.8122 28.8122 31.4961 25.5003 31.4998V32.9998C25.5003 33.8284 24.8283 34.4999 24.0002 34.4999C23.1716 34.4999 22.5001 33.8284 22.5001 32.9998V31.4998H19.5004V32.9998C19.5004 33.8284 18.8284 34.4999 18.0003 34.4999C17.1717 34.4999 16.5002 33.8284 16.5002 32.9998V31.4998H12.0004C11.1718 31.4998 10.5003 30.8282 10.5003 30.0001C10.5003 29.1716 11.1718 28.5 12.0004 28.5H13.5V13.5H12.0004C11.1718 13.5 10.5003 12.8285 10.5003 11.9999C10.5003 11.1714 11.1718 10.4998 12.0004 10.4998H16.5002V9.00021C16.5002 8.17166 17.1717 7.50012 18.0003 7.50012C18.8288 7.50012 19.5004 8.17166 19.5004 9.00021V10.4998H22.5001V9.00021C22.5001 8.17166 23.1716 7.50012 24.0002 7.50012C24.8287 7.50012 25.5003 8.17166 25.5003 9.00021V10.4998C28.7998 10.4861 31.486 13.1494 31.5002 16.4489C31.5075 18.1962 30.7499 19.8593 29.4265 21C30.7375 22.128 31.4942 23.77 31.5002 25.4998Z"
                    fill="#FFAB2D"></path>
                </svg> */}
                <img
                  src={`${process.env.REACT_APP_API_BASE_URL}/uploads/${row_three[1]?.logo}`}
                  alt="symbol"
                  className="rounded-circle"
                  style={{
                    width: "42px",
                    height: "42px",
                    objectFit: "cover",
                  }}
                />

                <div className="ms-3">
                  <h2 className="text-black fs-20 mb-0 font-w600">
                    {row_three[1]?.name}
                  </h2>
                  <span>
                    {(() => {
                      const coinPrice = prices.find(
                        (item) => item.id === coin.id
                      );
                      if (!coinPrice) return null;

                      return (
                        <>
                          {coinPrice.price} (
                          <span style={{ color: coinPrice.color }}>
                            {coinPrice.percentChange}
                          </span>
                          )
                        </>
                      );
                    })()}
                  </span>
                </div>
              </div>
              <BtcDigitalChartIndex4 />
              <div className="card-footer"></div>
            </div>
          </Link>
        </div>

        <div className="col-xl-6 col-xxl-6">
          <div className="card h-89">
            <div className="card-header border-0 pb-0">
              <h4 className="fs-20 font-w600 m-0">Markets Overview</h4>
            </div>

            <div className="card-body pt-0 px-0">
              {coin.slice(0, 5).map((coin) => (
                <Link
                  key={coin.id}
                  to={`/coin-details/${coin.id}`}
                  className="d-flex justify-content-between align-items-center px-3 py-2 text-decoration-none text-black"
                  style={{
                    transition: "background 0.3s",
                    borderRadius: "6px",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background =
                      "rgba(108, 117, 125, 0.15)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "transparent";
                  }}
                >
                  <div className="d-flex align-items-center">
                    <div
                      style={{
                        width: 42,
                        height: 42,
                        overflow: "hidden",
                        borderRadius: 6,
                      }}
                    >
                      <img
                        src={`${process.env.REACT_APP_API_BASE_URL}/uploads/${coin.logo}`}
                        alt={coin.symbol}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                    <div className="ms-3">
                      <h6 className="mb-0">{coin.symbol}</h6>
                      <span className="fs-12">{coin.name}</span>
                    </div>
                  </div>

                  <div className="text-end">
                    <h6
                      className="mb-0"
                      style={{ color: coinColors?.[coin.id] }}
                    >
                      $
                      {Number(
                        coinPrices?.[coin.id] ??
                          coin.coinPriceHistory?.[0]?.price ??
                          0
                      ).toFixed(2)}
                    </h6>
                    <span
                      className="fs-12"
                      style={{ color: coinColors?.[coin.id] ?? "#000" }}
                    >
                      {coin24HPer?.[coin.id] ??
                        coin.coinPriceHistory?.[0]?.percentChange ??
                        "0%"}
                    </span>
                  </div>
                </Link>
              ))}

              <div className="card-footer text-center pt-2  border-0">
                <Link to="/market" className="btn-link text-black">
                  Show more <i className="fa fa-caret-right"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="col-xl-6 col-xxl-6">
          <div className="card h-88">
            <div className="card-header">
              <h4 className="heading mb-0">Activity</h4>
            </div>
            <div
              className="card-body pt-0"
              style={{ maxHeight: 350, overflowY: "auto" }}
            >
              <div className="table-responsive">
                <table className="table border-0 mb-0 activity-tbl">
                  <thead>
                    <tr className="bg-pale-dark">
                      <th>#</th>
                      <th>Transaction id</th>
                      <th className="text-start">Qty.</th>
                      <th>Time</th>
                      <th className="text-end">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableData.map((item, ind) => (
                      <tr key={ind}>
                        <td className="">{ind + 1}</td>
                        <td className="text-primary">
                          {item.transactionNumber}
                        </td>
                        <td className="text-nowrap">{item.title}</td>
                        <td>
                          <span className="timeago text-nowrap">
                            {item.updatedAt}
                          </span>
                        </td>
                        <td className="text-end">
                          <span className={`label ${statusColor[item.status]}`}>
                            {item.status}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Home;
